import React, { useEffect, useState } from 'react'
import SpeakerCard from './SpeakerCard/SpeakerCard'
import { normalizeText } from '../../../helpers/Utils';
import styles from './SpeakerFilters.module.css';

function SpeakerFilters({ speakerList, selectedList, updateSelectedList, closeModal }) {
  const [temporalList, setTemporalList] = useState(selectedList);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredList, setFilteredList] = useState(speakerList);

  function handleToggle(speaker) {
    const { id } = speaker;
    if (temporalList.includes(id)) {
      const newList = temporalList.filter(idInList => idInList !== id);
      setTemporalList(newList);
    } else {
      const newList = [...temporalList];
      newList.push(id);
      setTemporalList(newList);
    }
  }

  function commitFilters() {
    updateSelectedList(temporalList);
    closeModal();
  }

  function clearFilters() {
    setTemporalList([]);
  }

  useEffect(() => {
    if (searchTerm.length > 2) {
      const newList = speakerList.filter(speaker => {
        const { firstName, lastName } = speaker;
        const normalizedFirstName = normalizeText(firstName);
        const normalizedLastName = normalizeText(lastName);
        const normalizeSearchTerm = normalizeText(searchTerm);

        if (normalizedFirstName.includes(normalizeSearchTerm) || normalizedLastName.includes(normalizeSearchTerm)) {
          return true;
        }
        return false;
      });
      setFilteredList(newList);
    } else {
      setFilteredList(speakerList);
    }
  }, [closeModal, searchTerm, speakerList]);

  return (
    <div className='speakers-filters-backdrop'>
      <div className='speakers-filters-modal'>
        <div className='speakers-searchbar'>
          <h3 className='search-title'>Buscar oradores</h3>
          <div className='speakersTextSearchPanel'>
            <input
              type='text'
              placeholder='Buscar...'
              className='searchBar'
              value={searchTerm}
              onChange={({ target }) => setSearchTerm(target.value)}
            />
          </div>
          <div className={styles.trashAndCountContainer}>
            <span className={styles.text}>{`${temporalList.length} oradores seleccionados.`}</span>
            <button onClick={clearFilters} className={styles.clearButton}>
              <i className='simple-icon-trash' />
            </button>
          </div>
          <div className={styles.buttonContainer}>
            <button onClick={closeModal} className={styles.secondaryButton}>Cerrar</button>
            <button onClick={commitFilters} className={styles.primaryButton}>Aceptar</button>
          </div>
        </div>
        <div className='speakers-filters-speakers-container'>
          {
            filteredList?.map(speaker => <SpeakerCard
              speaker={speaker}
              key={`speaker_${speaker.id}`}
              isSelected={temporalList.includes(speaker.id)}
              toggleSelection={handleToggle} />)
          }
        </div>
      </div>
    </div>

  )
}

export default SpeakerFilters